import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { BiSolidLeftArrow, BiSolidRightArrow } from "react-icons/bi";
import "./SquareDiv.css";

const DualSquareSelector = forwardRef(({ items =[], onSelectedItemsChange, labelSelect, labelSelected, enableSearch = false,loading=false }, ref) => {
    const [FItems,setFItems]=useState([]) 
    const [originalItems, setOriginalItems] = useState(FItems.map((item, index) => ({ ...item, index })));
    const [availableItems, setAvailableItems] = useState(originalItems);
    const [selectedItems, setSelectedItems] = useState([]);
    const [itemsToMove, setItemsToMove] = useState([]);
    const [searchAvailable, setSearchAvailable] = useState('');
    const [searchSelected, setSearchSelected] = useState('');
    const [squareLoading,setSquareLoading]=useState(loading)
    useEffect(() => {
        if (onSelectedItemsChange) {
            onSelectedItemsChange(selectedItems);
        }
    }, [selectedItems, onSelectedItemsChange]);
    useEffect(()=>{setFItems(items);setOriginalItems(items.map((item, index) => ({ ...item, index }))); setAvailableItems(originalItems)},[items])
    const handleItemClick = (item, from) => {
        if (!item) return;

        if (from === 'available') {
            setItemsToMove((prev) =>
                prev.some((i) => i.value === item.value) ? prev.filter((i) => i.value !== item.value) : [...prev, item]
            );
        } else if (from === 'selected') {
            setItemsToMove((prev) =>
                prev.some((i) => i.value === item.value) ? prev.filter((i) => i.value !== item.value) : [...prev, item]
            );
        }
    };

    const moveToSelected = () => {
        const newItemsToAdd = itemsToMove.filter((item) => !selectedItems.some((i) => i.value === item.value));
        setSelectedItems((prev) => [...prev, ...newItemsToAdd]);
        setAvailableItems((prev) => prev.filter(({ value }) => !itemsToMove.some((i) => i.value === value)));
        setItemsToMove([]);
    };

    const moveToAvailable = () => {
        const newItemsToAdd = itemsToMove.filter((item) => !availableItems.some((i) => i.value === item.value));
        const movedItems = newItemsToAdd.map((item) =>
            originalItems.find((originalItem) => originalItem.value === item.value)
        );
        const newAvailableItems = [...movedItems, ...availableItems];
        newAvailableItems.sort((a, b) => a.index - b.index);
        setAvailableItems(newAvailableItems);
        setSelectedItems((prev) => prev.filter((item) => !itemsToMove.some((i) => i.value === item.value)));
        setItemsToMove([]);
    };

    // Expose resetSelection function to parent component
    useImperativeHandle(ref, () => ({
        resetSelection: () => {
            setAvailableItems(originalItems);
            setSelectedItems([]);
            setItemsToMove([]);
            setSearchAvailable('');
            setSearchSelected('');
        }
    }));

    // Filter items based on search queries
    const filteredAvailableItems = availableItems.filter((item) =>
        item.label.toLowerCase().includes(searchAvailable.toLowerCase())
    );
    const filteredSelectedItems = selectedItems.filter((item) =>
        item.label.toLowerCase().includes(searchSelected.toLowerCase())
    );

    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px', alignItems: "center" }}>
            {/* Available Items */}
            <div style={{ width: "100%" }}>
                <div style={{ paddingBottom: 10 }}>Available {labelSelect}</div>
                {enableSearch && (
                    <input
                        type="text"
                        value={searchAvailable}
                        onChange={(e) => setSearchAvailable(e.target.value)}
                        placeholder="Search..."
                        style={{ width: '100%', padding: '3px', marginBottom: '10px' }}
                    />
                )}
                <div
                    style={{
                        border: '1px solid grey',
                        padding: '10px',
                        width: '100%',
                        minHeight: '300px',
                        maxHeight: '300px',
                        overflowY: 'scroll',
                        backgroundColor: '#FFF',
                        borderColor:"rgba(0,0,0,0.3)"
                    }}
                >
                    {filteredAvailableItems.length > 0 ? (
                        filteredAvailableItems.map((item) => (
                            item ? (
                                <div
                                    key={item.value}
                                    style={{
                                        padding: '3px',
                                        cursor: 'pointer',
                                        borderBottom: '1px solid #ddd',
                                        backgroundColor: itemsToMove.some((i) => i.value === item.value) ? '#e0e0e0' : 'transparent'
                                    }}
                                    onClick={() => handleItemClick(item, 'available')}
                                >
                                    {item.label}
                                </div>
                            ) : (
                                <div key={Math.random()}>No valid item</div>
                            )
                        ))
                    ) : (
                        <div>No items available</div>
                    )}
                </div>
            </div>
            {/* Control Buttons */}
            <div>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <BiSolidRightArrow onClick={moveToSelected} size={50} style={{ cursor: 'pointer', margin: '10px 0' }} className="coustom-button" />
                    <BiSolidLeftArrow onClick={moveToAvailable} size={50} style={{ cursor: 'pointer' }} className="coustom-button" />
                </div>
            </div>
            {/* Selected Items */}
            <div style={{ width: "100%" }}>
                <div style={{ paddingBottom: 10 }}>Selected {labelSelect}</div>
                {enableSearch && (
                    <input
                        type="text"
                        value={searchSelected}
                        onChange={(e) => setSearchSelected(e.target.value)}
                        placeholder="Search..."
                        style={{ width: '100%', padding: '5px', marginBottom: '10px' }}
                    />
                )}
                <div
                    style={{
                        border: '1px solid grey',
                        padding: '10px',
                        width: '100%',
                        minHeight: '300px',
                        maxHeight: '300px',
                        overflowY: 'scroll',
                        backgroundColor: '#f9f9f9',
                        borderColor:"rgba(0,0,0,0.3)"

                    }}
                >
                    {filteredSelectedItems.length > 0 ? (
                        filteredSelectedItems.map((item) => (
                            item ? (
                                <div
                                    key={item.value}
                                    style={{
                                        padding: '5px',
                                        cursor: 'pointer',
                                        borderBottom: '1px solid #ddd',
                                        backgroundColor: itemsToMove.some((i) => i.value === item.value) ? '#e0e0e0' : '#fff'
                                    }}
                                    onClick={() => handleItemClick(item, 'selected')}
                                >
                                    {item.label}
                                </div>
                            ) : (
                                <div key={Math.random()}>No valid item</div>
                            )
                        ))
                    ) : (
                        <div>No items selected</div>
                    )}
                </div>
            </div>
        </div>
    );
});

export default DualSquareSelector;
